import React, {Component, ErrorInfo, ReactNode} from 'react';
import {Platform, StyleSheet, View} from 'react-native';

import {
  NAVIGATION_STATE_KEY,
  NAVIGATION_TIMESTAMP_KEY,
  NAVIGATION_URL_KEY,
} from '../constants/sessionStorageKeys';
import theme from '../style/theme';

import Text from './ui-controls/Text';

type ErrorBoundaryProps = {
  children: ReactNode;
  message?: string;
};

type ErrorBoundaryState = {
  hasError: boolean;
  error?: Error | null;
  errorInfo?: ErrorInfo | null;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {hasError: true};
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.log('error boundary caught', error, errorInfo);
    if (Platform.OS === 'web') {
      sessionStorage.removeItem(NAVIGATION_STATE_KEY);
      sessionStorage.removeItem(NAVIGATION_TIMESTAMP_KEY);
      sessionStorage.removeItem(NAVIGATION_URL_KEY);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <View style={styles.main}>
          <Text style={styles.exclamation}>Something went wrong!</Text>
          <Text style={styles.niceText}>We are looking into it.</Text>
          <Text>{this.props.message ? this.props.message : null}</Text>
        </View>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

const styles = StyleSheet.create({
  main: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  exclamation: {
    fontSize: 24,
    color: theme.colour.text.heading.primary,
    fontWeight: '700',
  },
  niceText: {
    fontSize: 16,
    color: theme.colour.text.heading.primary,
    fontWeight: '600',
  },
});
